@if (loading$ | async) {
  <!-- <div class="global-loader loader">
    <div class="whirly-loader"></div>
  </div> -->
  <div class="d-flex justify-content-center loader">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden"></span>
    </div>
    <!-- <img src="../../../assets/img/logo.png"> -->
  </div>
}
